import React, { useRef, useState } from "react";
import "./Uploaded_img_holder.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

function Uploaded_img_holder({
  uploadedImages,
  setUploadedImages,
  imageFiles,
}) {
  const fileInputRef = useRef(null);

  // ✅ Multiple Images + Names
  const [selectedFileName, setSelectedFileName] = useState([]);

  // ✅ Upload Multiple Images
  const handleUpload = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    // Create preview objects
    const newImages = files.map((file) => ({
      id: Date.now() + Math.random(),
      file: file,
      preview: URL.createObjectURL(file),
      name: file.name,
      type: file.type,
    }));

    setUploadedImages((prev) => [...prev, ...newImages]);

    // ✅ Save file names also
    setSelectedFileName((prev) => [...prev, ...files.map((f) => f.name)]);

    // reset input (so same image can be uploaded again)
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  // ✅ Remove Image
  const handleRemove = (id, name) => {
    setUploadedImages((prev) => prev.filter((img) => img.id !== id));
    setSelectedFileName((prev) => prev.filter((n) => n !== name));
  };

  // console.log(uploadedImages,"uploadedImages uploadedImages");
  // console.log(selectedFileName,"selectedFileName selectedFileName");

  return (
    <>
      <section className="file_upload">
        <div className="uploaded_img_holder">
          {/* Upload Box */}
          <div
            className="upload_div"
            onClick={() => fileInputRef.current.click()}
            style={{ cursor: "pointer" }}
          >
            <div className="plus_div">
              <img
                src="/assest/luxury_images/other/add.png"
                className="plus_img"
                alt="add"
              />
            </div>

            <p className="below_text">Upload Here</p>

            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              accept=".jpg,.png,.jpeg,.pdf"
              multiple
              onChange={handleUpload}
            />
          </div>
          {uploadedImages?.length > 0
            ? uploadedImages.map((img, index) => (
                <div className="uploaded_img" key={index}>
                  {img.type === "application/pdf" ? (
                    <iframe
                      src={img.preview}
                      title={img.name}
                      width="120"
                      height="120"
                      className="product_img"
                    />
                  ) : (
                    <img
                      src={img.preview}
                      alt={img.name}
                      className="product_img"
                    />
                  )}
                </div>
              ))
            : imageFiles?.map((img, index) => (
                <div className="uploaded_img" key={index}>
                  <img src={img} alt="preview" className="product_img" />
                </div>
              ))}
          {/* Uploaded Images */}
        </div>

        {/* Attachment names */}
        {/* {selectedFileName.length > 0 && (
        <div className="mt-2">
          {selectedFileName.map((name, index) => (
            <p key={index} className="attachment_name">
              📎 {name}
            </p>
          ))}
        </div>
      )} */}
      </section>
    </>
  );
}

export default Uploaded_img_holder;

// import React, { useRef, useState } from "react";
// import "./Uploaded_img_holder.css"
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faXmark } from "@fortawesome/free-solid-svg-icons";

// function Uploaded_img_holder({ uploadedImages, imageFiles, setUploadedImages }) {
//   const fileInputRef = useRef(null);

//   // ✅ Multiple Images + Names
//   const [selectedFileName, setSelectedFileName] = useState([]);

//   // ✅ Upload Multiple Images
//   const handleUpload = (e) => {
//     const files = Array.from(e.target.files);
//     if (!files.length) return;

//     // Create preview objects
//     const newImages = files.map((file) => ({
//       id: Date.now() + Math.random(),
//       file: file,
//       preview: URL.createObjectURL(file),
//       name: file.name,
//     }));

//     setUploadedImages((prev) => [...prev, ...newImages]);

//     // ✅ Save file names also
//     setSelectedFileName((prev) => [...prev, ...files.map((f) => f.name)]);

//     // reset input (so same image can be uploaded again)
//     if (fileInputRef.current) {
//       fileInputRef.current.value = "";
//     }
//   };

//   // ✅ Remove Image
//   const handleRemove = (id, name) => {
//     setUploadedImages((prev) => prev.filter((img) => img.id !== id));
//     setSelectedFileName((prev) => prev.filter((n) => n !== name));
//   };

//   // console.log(uploadedImages,"uploadedImages uploadedImages");
//   // console.log(selectedFileName,"selectedFileName selectedFileName");

//   return (
//     <>
//       <section className="file_upload">

//         <div className="uploaded_img_holder">
//           {/* Upload Box */}
//           <div
//             className="upload_div"
//             onClick={() => fileInputRef.current.click()}
//             style={{ cursor: "pointer" }}
//           >
//             <div className="plus_div">
//               <img
//                 src="/assest/luxury_images/other/add.png"
//                 className="plus_img"
//                 alt="add"
//               />
//             </div>

//             <p className="below_text">Upload Here</p>

//             <input
//               type="file"
//               ref={fileInputRef}
//               style={{ display: "none" }}
//               accept=".jpg,.png,.jpeg,pdf"
//               multiple
//               onChange={handleUpload}
//             />
//           </div>

// {uploadedImages?.length > 0
//   ? uploadedImages.map((img, index) => (
//     <div className="uploaded_img" key={index}>
//       <img src={img.preview} alt={img.name} className="product_img" />
//     </div>
//   ))
//   : imageFiles?.map((img, index) => (
//     <div className="uploaded_img" key={index}>
//       <img src={img} alt="preview" className="product_img" />
//     </div>
//   ))}
//         </div>

//         {/* Attachment names */}
//         {/* {selectedFileName.length > 0 && (
//           <div className="mt-2">
//             {selectedFileName.map((name, index) => (
//               <p key={index} className="attachment_name">
//                 📎 {name}
//               </p>
//             ))}
//           </div>
//         )} */}
//       </section>
//     </>
//   );
// }

// export default Uploaded_img_holder;
